/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = formatPrice(price);
    if (comparing) {
      res +=
        ' <s class="margin-left-xxxs">' +
        formatPrice(compare_at_price) +
        '</s> ';
      res +=
        ' <span class="bg-primary color-white text-xs padding-x-xxs line-height-lg margin-left-xxxs text-uppercase">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          var res = 'From ' + formatPrice(min);
          if (Number(this.compare_at_price) && Number(this.compare_at_price) > Number(this.price)) {
            res += '<span class="bg-primary color-white text-xs padding-x-xxs line-height-lg margin-left-xxxs text-uppercase">Sale</span>'
          }
          return res;
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          var res = 'From ' + formatPrice(min);
          if (Number(this.compare_at_price) && Number(this.compare_at_price) > Number(this.price)) {
            res += '<span class="bg-primary color-white text-xs padding-x-xxs line-height-lg margin-left-xxxs text-uppercase">Sale</span>'
          }
          return res;
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },

    displayProductOffers: function(t, render) {
      let html = '';
      let counter = 0;
      let exclude_from_offers = [];
      const collections = this.collections.sort();
      const productCollections = window.productCollection.sort();
      
      if (!collections || !productCollections)
        return;

      if (this.meta.offer && this.meta.offer.exclude) {
        for (var exclude of this.meta.offer.exclude) {
          exclude_from_offers.push(parseInt(exclude.replace('gid://shopify/Collection/','')));
        }
      }

      for (var collection of collections) {
        for(var i = 0; i < productCollections.length; i++){
          if(productCollections[i].handle == collection && counter < 1 && !exclude_from_offers.includes(productCollections[i].id)){
            counter++;
            html += `
              <div class="product-item--offer inline-block" style="--offer-bg: ${productCollections[i].colour}">
              ${productCollections[i].title}
              </div>
            `;
          }
        }
      }
      return render(html);
    },
    displayProductIcons: function (t, render) {
      var html = '';

      if (!this.meta || !this.meta.product_info)
        return;

      try {
        var images = JSON.parse(this.meta.product_info.icon_image);
        var isBadges = JSON.parse(this.meta.product_info.product_card_badge);
        var titles = JSON.parse(this.meta.product_info.product_card_title);

        


        for (var i=0; i<images.length; i++) {
          var image = images[i];
          var isBadge = isBadges[i];
          var title = titles[i];

          if (!isBadge)
            continue;
          if (image) {
            html += `
            <div class="product-icons flex justify-center gap-xs items-center padding-y-xxxs padding-x-xxs bg-white">
              <img data-src="${image[0].cloudinary_src + 'w_19,h_19'}"
                alt="${escapeHtml(title)}"
                width="19"
                height="19"
                loading="lazy"
                class="lazyload block"
              >
              <span class="text-sm@md text-xs font-secondary">${title}</span>
            </div>
            `;
          }
        }
      } catch (e) {
        console.log('Error creating product icons', e);
      }

      return render(html);
    },
    stockNotice: function stockNotice() {
      if (this.inventory_quantity > 0) {
        return ''
      } else {
        return `
        <div class="text-component margin-bottom-sm">
          <p class="js-stock-notice color-error" data-product="${this.objectID}">
            Out of stock
          </p>
        </div>`;
      }
    },
    instantsearchOkendoReviews: function instantsearchOkendoReviews() {
      if (!this.meta || !this.meta.okendo)
        return;
      
      return this.meta.okendo.ProductListingSnippet;
    },

    productData: function (t = 'product', render) {
      return '';
      delete this.description;
      delete this._snippetResult.body_html_safe;
      delete this._highlightResult.body_html_safe;
      delete this.body_html_safe;
      return `data-${t}='${escapeHtml(JSON.stringify(this))}'`;
    }
  };

  [ 50,160,250,320,640,720,900,1080,
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          let vendor = window.vendors.find(x => x.name === this.vendor);
          
          if (vendor && vendor.image) {
            if (vendor.resized_images[size]) {
              return vendor.resized_images[size];
            } else {
              return vendor.image;
            }
          } else {
            return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
          }
        }

        if (_size === 'original') {
          return image;
        }

        if (!isNaN(_size)) {
          _size = _size + 'x';
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
